import { Selector } from 'react-redux';
import { createSelector } from 'reselect';
import { RootState } from '../../redux/root-reducer';
import { ICastingDirector } from '../../types/global/helper';

export const castingDirectorSelector: Selector<RootState, ICastingDirector[]> = createSelector(
    (state: RootState) => state.audition,
    audition => audition.castingDirector ?? [],
);
